export const AUTO_SAVE_INITIAL_STATUS = 'initial';
export const AUTO_SAVE_PENDING_STATUS = 'pending';
export const AUTO_SAVE_SAVING_STATUS = 'saving';
export const AUTO_SAVE_SAVED_STATUS = 'saved';
export const AUTO_SAVE_ERROR_STATUS = 'error';
